// Mock data for Email Signature Generator

// Helper to read env with fallback (build-time). Use REACT_APP_* variables.
const env = (key, fallback) => {
  const v = process.env[key];
  return typeof v === 'undefined' || v === '' ? fallback : v;
};

export const defaultSignatureData = {
  // Step 1 - Basic Info
  fullName: env('REACT_APP_DEFAULT_FULLNAME', ''),
  fullNameStyles: { bold: false, italic: false, underline: false },
  position: env('REACT_APP_DEFAULT_POSITION', ''),
  positionStyles: { bold: false, italic: false, underline: false },
  company: env('REACT_APP_DEFAULT_COMPANY', ''),
  companyStyles: { bold: false, italic: false, underline: false },
  email: env('REACT_APP_DEFAULT_EMAIL', ''),
  phone: env('REACT_APP_DEFAULT_PHONE', ''),
  website: env('REACT_APP_DEFAULT_WEBSITE', ''),

  // Step 2 - Media & Style
  logo: null,
  // Allow build-time default logo/banner via REACT_APP_DEFAULT_LOGO_URL / REACT_APP_DEFAULT_BANNER_URL
  logoPreview: env('REACT_APP_DEFAULT_LOGO_URL', null),
  logoBorderRadius: Number(env('REACT_APP_DEFAULT_LOGO_BORDER', 0)),
  banner: null,
  bannerPreview: env('REACT_APP_DEFAULT_BANNER_URL', null),
  bannerBorderRadius: Number(env('REACT_APP_DEFAULT_BANNER_BORDER', 0)),

  // Palette can be overridden at build time per client
  primaryColor: env('REACT_APP_PRIMARY_COLOR', '#2563eb'),
  secondaryColor: env('REACT_APP_SECONDARY_COLOR', '#64748b'),
  accentColor: env('REACT_APP_ACCENT_COLOR', '#3b82f6'),
  backgroundColor: env('REACT_APP_BACKGROUND_COLOR', '#ffffff'),
  fontFamily: env('REACT_APP_FONT_FAMILY', 'Inter'),

  // Step 3 - Social Links
  facebook: env('REACT_APP_DEFAULT_FACEBOOK', ''),
  twitter: env('REACT_APP_DEFAULT_TWITTER', ''),
  linkedin: env('REACT_APP_DEFAULT_LINKEDIN', ''),
  instagram: env('REACT_APP_DEFAULT_INSTAGRAM', ''),
  youtube: env('REACT_APP_DEFAULT_YOUTUBE', ''),
  tiktok: env('REACT_APP_DEFAULT_TIKTOK', ''),

  // Step 4 - Custom Links
  customLinks: [],

  // Template settings
  templateStyle: env('REACT_APP_DEFAULT_TEMPLATE_STYLE', 'classico'),
  templateSize: env('REACT_APP_DEFAULT_TEMPLATE_SIZE', 'medio')
};

export const fontOptions = [
  { value: 'Inter', label: 'Inter' },
  { value: 'Arial', label: 'Arial' },
  { value: 'Roboto', label: 'Roboto' },
  { value: 'Open Sans', label: 'Open Sans' },
  { value: 'Poppins', label: 'Poppins' },
  { value: 'Lato', label: 'Lato' },
  { value: 'Montserrat', label: 'Montserrat' },
];

export const templateStyles = [
  { value: 'classico', label: 'Clássico' },
  { value: 'minimalista', label: 'Minimalista' },
  { value: 'criativo', label: 'Criativo' },
  { value: 'compacto', label: 'Compacto' },
  { value: 'moderno', label: 'Moderno' },
  { value: 'profissional', label: 'Profissional' },
  { value: 'elegante', label: 'Elegante' },
  { value: 'negrito', label: 'Negrito' },
];

export const templateSizes = [
  { value: 'pequeno', label: 'Pequeno' },
  { value: 'medio', label: 'Médio' },
  { value: 'grande', label: 'Grande' },
];

export const sampleSignatureData = {
  fullName: 'João Silva',
  fullNameStyles: { bold: true, italic: false, underline: false },
  position: 'Desenvolvedor Frontend',
  positionStyles: { bold: false, italic: false, underline: false },
  company: 'Empresa Tech',
  companyStyles: { bold: false, italic: false, underline: false },
  email: 'joao@empresa.com',
  phone: '+55 (11) 99999-9999',
  website: 'www.empresa.com',
  logo: null,
  logoPreview: null,
  logoBorderRadius: 8,
  banner: null,
  bannerPreview: null,
  bannerBorderRadius: 4,
  primaryColor: '#2563eb',
  secondaryColor: '#64748b',
  accentColor: '#3b82f6',
  backgroundColor: '#ffffff',
  fontFamily: 'Inter',
  facebook: 'https://facebook.com/joaosilva',
  twitter: '',
  linkedin: 'https://linkedin.com/in/joaosilva',
  instagram: 'https://instagram.com/joaosilva',
  youtube: '',
  tiktok: '',
  customLinks: [
    { id: '1', label: 'Portfólio', url: 'https://portfolio.joaosilva.com' }
  ],
  templateStyle: 'classico',
  templateSize: 'medio'
};
